
import { useEffect, useRef } from 'react';
import bluetick from '../../../assets/images/bluetick.svg';
import add from '../../../assets/images/icons8-plus-32.png';

export default function EditEquationCard ( props ) {
    
    const {  equation, handleExpand, currentEquation, handleOnChangeEquation, handleSaveEquation, handleActive } = props;
   let inputRef = useRef(null);
   
   useEffect(()=>{
    inputRef.current.focus();
   }, [])

    return(
        <div 
            key={equation.equationId} 
            className={` 
                    "h-[200px] flex-col py-4" 
                    ${(equation.active) 
                    ? "bg-lightPrimary" 
                    : "bg-bgColor"}  w-[500px] pl-8 pr-4 py-[12px]  mt-2  rounded-sm cursor-pointer`} 
            onClick={() => handleExpand(equation.equationId)}
         >
        
        <div className='flex justify-between w-full'>
            { equation.gameType }
            <img 
                src={equation?.active ? bluetick : add} 
                alt="" 
                className='w-6' 
                // onClick={(e) => handleTick(e, equation.equationId)}
                onClick={(e)=> {
                    // e.stopPropagation()
                    // handleActive(equation.equationId);
                }}
            />
        </div>

        <div className='flex' >
            <div className='' onClick={(e) => e.stopPropagation()} >
                <input 
                    ref={inputRef}
                    type="number" 
                    placeholder='Exchange Unit Rate' 
                    className=' w-[300px] px-2 py-2 font-semibold outline-none mt-4' 
                    step="0.01" 
                    min="0"
                    name="exchangeUnitRate" 
                    value={ currentEquation.exchangeUnitRate } 
                    onChange={ (e) => handleOnChangeEquation(e) }                           
                />
                 <input 
                    type="text" 
                    placeholder='Equation' 
                    className=' w-[300px] px-2 py-2 font-semibold outline-none mt-4' 
                    name="equation"
                    value={ currentEquation.equation } 
                    onChange={ (e) => handleOnChangeEquation(e) } 
                />

                {/*
                Equation Modal
                <div 
                    className='w-[300px] px-2 py-2 bg-white mt-2 flex justify-between' 
                    
                >
                    {equation.equation} 
                    <img 
                        src={edit} 
                        alt="" 
                        className='w-6' 
                        onClick={()=>setEditEquation(true)} 
                    />
                </div> */}
                <div className='flex items-center mt-4'>
                    <input 
                      id='active status'
                      type="checkbox"
                      name='showPositive'
                    //   value={currentEquation.showPositive
                    //   }
                      checked={ currentEquation.showPositive }
                      onChange={(e)=> handleOnChangeEquation(e)}  
                    />
                    <div className='ml-2' >Show Positive</div>
                </div>
            </div>
            <div className='flex flex-col justify-end ml-10 text-white'>
                <button 
                    className='w-[100px] h-[35px] bg-primary rounded-md' 
                    onClick={handleSaveEquation} >
                        Save
                </button>
                {/* <button 
                 className='w-[100px] h-[35px] bg-attractive2 mt-2 rounded-md'
                 onClick={(e) => e.stopPropagation()}>
                    Remove
                </button> */}
            </div>
        </div> 
    </div>
    )
}